export default {
    namespaced:true,
    state:{
        jsonCertificado:[],
        jsonInstanciaCertificado:[]
    },
    mutations:{
        cambioArrayCertificado(state,payload){
            state.jsonCertificado = payload;
        },
        cambioArrayInstanciaCertificado(state,payload){
            state.jsonInstanciaCertificado = payload;
        }   
    },
    actions:{
        updateArrayCertificado({commit},payload){
            commit('cambioArrayCertificado',payload)
        },
        updateArrayInstanciaCertificado({commit},payload){
            commit('cambioArrayInstanciaCertificado',payload)
        },
    },
    getters:{
       
    }
}